import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

/**
 * Clear Search Param hook
 * Remove a search param value from the URL string for any arbitrary reason.
 * @param paramName Search param key/name to possibly remove
 * @param shouldUnset Should the param be removed?
 * @example <caption>Manage the shouldUnset value using useState.</caption>
 * const [shouldUnset, setShouldUnset] = useState(false);
 * useClearSearchParam('myParamName', shouldUnset);
 */
export const useClearSearchParam = (paramName: string, shouldUnset = false) => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    if (shouldUnset && urlParams.has(paramName)) {
      urlParams.delete(paramName);
      history.replace({
        ...location,
        search: `?${urlParams.toString()}`,
      });
    }
  }, [location, paramName, shouldUnset]);
};
